import store from '../../admin/store'
const apiUrl = `${window.APP_CONFIG.REACT_APP_API_URL}api`

/**
 * Get user slug
 *
 * @param {string|null} slug - if not defined, return slug of authed user
 * @return {string}
 * @throws Error
 */
const userSlug = (slug = null) => {
    if (slug && slug !== '') {
        return slug
    }

    return store.getState()?.auth?.user?.slug || throw Error('User is not defined!')
}

/**
 * Store new user sports
 *
 * @param {Array} sports - array of sport ids
 * @param {string|null} slug
 * @return {Promise}
 */
export const storeSports = (sports, slug = null) => {
    return window.axios.post(`${apiUrl}/users/${userSlug(slug)}/sport`, { sports: sports })
}

/**
 * Update sport in user sport
 *
 * @param {int} userSportId
 * @param {int} newSportId
 * @param {string|null} slug
 * @return {Promise}
 */
export const updateSport = (userSportId, newSportId, slug = null) => {
    return window.axios.put(`${apiUrl}/users/${userSlug(slug)}/sport/${userSportId}`, { sport_id: newSportId })
}

/**
 * Delete user sport
 *
 * @param {int} userSportId
 * @param {string|null} slug
 * @return {Promise}
 */
export const deleteSport = (userSportId, slug = null) => {
    return window.axios.delete(`${apiUrl}/users/${userSlug(slug)}/sport/${userSportId}`)
}

/**
 * Store new user sport location
 *
 * @param {Object} location - see parameter data, what method want
 * @param {string|null} slug
 * @return {Promise}
 */
export const storeLocation = (location, slug = null) => {
    const data = {
        user_sport_id: location.userSportId || location.user_sport_id,
        latitude: location.latitude,
        longitude: location.longitude,
        name: location.name || null,
        formatted_address: location.formattedAddress || location.formatted_address || null,
    }

    return window.axios.post(`${apiUrl}/users/${userSlug(slug)}/sport/location`, data)
}

/**
 * Update user sport location
 *
 * @param {Object} location - see parameter data, what method want
 * @param {int} userSportLocationId
 * @param {string|null} slug
 * @return {Promise}
 */
export const updateLocation = (location, userSportLocationId, slug = null) => {
    const data = {
        latitude: location.latitude,
        longitude: location.longitude,
        name: location.name || null,
        formatted_address: location.formattedAddress || location.formatted_address || null,
    }

    return window.axios.put(`${apiUrl}/users/${userSlug(slug)}/sport/location/${userSportLocationId}`, data)
}

/**
 * Delete user sport location
 *
 * @param {int} userSportLocationId
 * @param {string|null} slug
 * @return {Promise}
 */
export const deleteLocation = (userSportLocationId, slug = null) => {
    return window.axios.delete(`${apiUrl}/users/${userSlug(slug)}/sport/location/${userSportLocationId}`)
}

/**
 * Store relationships to user sport
 *
 * @param {Array} relationships - array of integers of relationships
 * @param {int} userSportId
 * @param {string|null} slug
 * @return {Promise}
 */
export const storeRelationships = (relationships, userSportId, slug = null) => {
    return window.axios.post(`${apiUrl}/users/${userSlug(slug)}/sport/${userSportId}/relationships`, { relationships: relationships })
}

/**
 * Store user sport achievement
 *
 * @param {Object} achievement - see parameter data in function
 * @param {string|null} slug
 * @return {Promise}
 */
export const storeAchievement = (achievement, slug = null) => {
    const data = {
        sport_id: achievement.sportId || achievement.sport_id,
        description: achievement.description,
    }

    return window.axios.post(`${apiUrl}/users/${userSlug(slug)}/achievement`, data)
}

/**
 * Update user sport achievement
 *
 * @param {Object} achievement - see parameter data in function
 * @param {int} achievementId
 * @param {string|null} slug
 * @return {Promise}
 */
export const updateAchievement = (achievement, achievementId, slug = null) => {
    const data = {
        sport_id: achievement.sportId || achievement.sport_id,
        description: achievement.description,
    }

    return window.axios.put(`${apiUrl}/users/${userSlug(slug)}/achievement/${achievementId}`, data)
}

/**
 * Delete achievement by id
 *
 * @param {int} achievementId
 * @param {string|null} slug
 * @return {Promise}
 */
export const deleteAchievement = (achievementId, slug = null) => {
    return window.axios.delete(`${apiUrl}/users/${userSlug(slug)}/achievement/${achievementId}`)
}

/**
 * Store user birthday
 *
 * @param {string} birthday
 * @param {string|null} slug
 * @return {Promise}
 */
export const storeBirthday = (birthday, slug = null) => {
    return window.axios.post(`${apiUrl}/users/${userSlug(slug)}/onboarding`, { birthday: birthday })
}
